import React from 'react';
import PropTypes from 'prop-types';

const SafeIcon = ({ icon: Icon, className, onClick, size }) => {
  if (!Icon) {
    console.error('Missing icon prop in SafeIcon component');
    return null;
  }

  return (
    <Icon 
      className={className || ''} 
      onClick={onClick}
      size={size}
    />
  );
};

SafeIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default SafeIcon;